var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{staticClass:"pb-3",attrs:{"id":"input-group-1","label-for":_vm.id}},[_c('b-form-input',{staticClass:"input",attrs:{"id":_vm.id,"value":_vm.stringValue,"type":_vm.type,"placeholder":_vm.placeholder,"disabled":_vm.isDisabled},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }